import { useMemo, useState } from "react";

import { Section, SubTabs, SubTab } from "components/layout";
import {
  TIVO_LAUNCH_TYPES,
  TiVoAppVariantVersion,
  TiVoLaunchAttributes,
  TiVoLaunchType,
} from "hooks/tivoApps/types";

import { LAUNCH_TYPE_LABELS } from "../../constants";
import { TEXTS } from "../constants";
import styles from "../TiVoAppDetailsTabs.scss";
import { LaunchAttrsIntentTab } from "./LaunchAttrsIntentTab";
import { LaunchAttrsUriTab } from "./LaunchAttrsUriTab";

type Tab = {
  attributes: TiVoLaunchAttributes;
  launchType: TiVoLaunchType;
  title: string;
};

export type LaunchAttrsSectionProps = {
  attributes: TiVoAppVariantVersion["launchAttributes"];
};

export function LaunchAttrsSection({ attributes }: LaunchAttrsSectionProps) {
  const [tabIndex, setTabIndex] = useState(0);

  const tabs = useMemo(() => {
    setTabIndex(0);
    return TIVO_LAUNCH_TYPES.map((launchType) => ({
      attributes: attributes[launchType],
      launchType: launchType,
      title: LAUNCH_TYPE_LABELS[launchType],
    })).filter<Tab>(
      (tab): tab is Tab =>
        tab.attributes !== undefined && tab.attributes !== null
    );
  }, [attributes]);

  const renderTab = (tab: Tab) => {
    if (tab.attributes?.intent) {
      return <LaunchAttrsIntentTab attributes={tab.attributes} />;
    }
    return <LaunchAttrsUriTab attributes={tab.attributes} />;
  };

  if (tabIndex >= tabs.length) {
    return null;
  }

  return (
    <Section header={TEXTS.VARIANT.ATTRS_SECTION_HEADER}>
      <SubTabs className={styles.tabs}>
        {tabs.map(({ launchType, title }, index) => (
          <SubTab
            key={launchType}
            active={index === tabIndex}
            text={title}
            onClick={() => setTabIndex(index)}
          />
        ))}
      </SubTabs>
      {renderTab(tabs[tabIndex])}
    </Section>
  );
}
